<template>
  <div class="w-full sm:w-full md:w-1/3 lg:w-1/3 xl:w-1/3 mb-4">
    <div id="entries-cards-loading" class="vs-con-loading__container">
      <vs-card class=" px-2 widget-card ">
        <card-header :title="$t('widget_entries_by_status')"></card-header>

        <div class="flex flex-wrap" style="aling-content:space-around">
          <div class="w-full px-4 my-5 ">
            <label class="text-sm opacity-75">{{ $t('client') }}</label>
            <v-select
              v-model="filters.client"
              :options="clients"
              class="w-full"
              :reduce="(client) => client.ClientId"
              label="ClientName"
              @input="loadCards"
            />
          </div>
          <div class="w-full px-4 mb-5">
            <statistics-card-line
              class="pequeña"
              icon="BellIcon"
              icon-right
              :statistic="cards.pending"
              statisticTitle="Pending"
              :hideChart="true"
              color="warning"
            />
          </div>
          <div class="w-full px-4 mb-5">
            <statistics-card-line
              class="pequeña"
              icon="PlayIcon"
              icon-right
              :statistic="cards.in_process"
              statisticTitle="In Process"
              :hideChart="true"
              color="info"
            />
          </div>
          <div class="w-full px-4 mb-5">
            <statistics-card-line
              icon="EyeIcon"
              icon-right
              :statistic="cards.under_review"
              statisticTitle="Under Review"
              :hideChart="true"
              color="info"
            />
          </div>
          <div class="w-full px-4 mb-5">
            <statistics-card-line
              icon="FlagIcon"
              icon-right
              :statistic="cards.load_order_ready"
              statisticTitle="Load Order Ready"
              :hideChart="true"
              color="success"
            />
          </div>
          <div class="w-full px-4 mb-5">
            <statistics-card-line
              icon="TruckIcon"
              icon-right
              :statistic="cards.shipped"
              statisticTitle="Shipped"
              :hideChart="true"
              color="success"
            />
          </div>
        </div>
      </vs-card>
    </div>
  </div>
</template>

<script>
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import vSelect from 'vue-select'
import loading from '@/mixins/Loading'
import client from '@/http/requests/client'
import entry from '@/http/requests/entry'
import CardHeader from './CardHeader.vue'
export default {
  components: {
    StatisticsCardLine,
    vSelect,
    CardHeader
  },
  mixins: [loading],
  computed: {
    isLoading() {
      return this.loading.clients || this.loading.cards
    },
  },
  watch: {
    isLoading(val) {
      if (val) {
        this.openLoading(`entries-cards-loading`)
      } else {
        this.closeLoading(`entries-cards-loading`)
      }
    },
  },
  data() {
    return {
      clients: [],
      cards: {
        in_process: 0,
        pending: 0,
        under_review: 0,
        load_order_ready: 0,
        documents_sent: 0,
        review_completed: 0,
        shipped: 0,
      },
      filters: {
        client: '',
      },
      loading: {
        clients: false,
        cards: false,
      },
    }
  },
  mounted() {
    this.getClients()
  },
  methods: {
    getClients() {
      this.loading.clients = true
      client
        .list()
        .then((res) => {
          this.clients = res.data.clients
          this.filters.client = this.clients[0].ClientId
          this.loadCards()
          this.loading.clients = false
        })
        .catch((err) => {
          this.loading.clients = false
        })
    },
    loadCards() {
      this.loading.cards = true
      entry
        .getBarPlotDate(this.filters.client)
        .then((res) => {
          let cards = res.data.data
          this.cards = {
            in_process: 0,
            pending: 0,
            under_review: 0,
            load_order_ready: 0,
            documents_sent: 0,
            review_completed: 0,
            shipped: 0,
          }
          //this.params.client_name=null
          //this.params.client=[this.filters.client]
          //this.params.status=['1','2','4','8']
          //this.params.filter=null
          //this.getData()
          cards.forEach((item) => {
            switch (item.name) {
              case 'Load Order Ready':
                this.cards.load_order_ready = Number(item.total)
                break
              case 'Under Review':
                this.cards.under_review = Number(item.total)
                break
              case 'Pending':
                this.cards.pending = Number(item.total)
                break
              case 'In Process':
                this.cards.in_process = Number(item.total)
                break
              case 'Documents Sent':
                this.cards.documents_sent = Number(item.total)
                break
              case 'Review Completed':
                this.cards.review_completed = Number(item.total)
                break
              case 'Shipped':
                this.cards.shipped = Number(item.total)
                break
              default:
                break
            }
          })
          this.loading.cards = false
        })
        .catch((err) => {
          console.log(err)
          this.loading.cards = false
        })
    },
  },
}
</script>